import PropTypes from 'prop-types';

import { tagShape, userShape } from '../../../shared/types';

const appointmentShape = PropTypes.shape({
  endAt: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  startAt: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(tagShape).isRequired,
  title: PropTypes.string.isRequired,
  users: PropTypes.arrayOf(userShape).isRequired,
  creator: userShape,
  description: PropTypes.string,
});

export default appointmentShape;
